/**
 * Kosh subscriptions API — typed wrappers over /api/v1/kosh/recurring-invoices.
 * apiClient unwraps the { success, data } envelope.
 */
import { apiClient } from './api-client';
import type { Paginated } from '@/types/kosh';
import type { KoshRecurringInvoice, KoshRecurringStatus } from '@/types/subscriptions';

type Query = Record<string, string | number | boolean | undefined>;

function rows<T>(data: Paginated<T> | T[] | null | undefined): T[] {
  if (!data) return [];
  return Array.isArray(data) ? data : data.items;
}

export const subscriptionsApi = {
  list: async (params?: Query): Promise<KoshRecurringInvoice[]> => {
    const { data } = await apiClient.get<
      Paginated<KoshRecurringInvoice> | KoshRecurringInvoice[]
    >('/kosh/recurring-invoices', { params });
    return rows<KoshRecurringInvoice>(data);
  },
  get: (id: string) =>
    apiClient.get<KoshRecurringInvoice>(`/kosh/recurring-invoices/${id}`).then((r) => r.data),
  transition: (id: string, to: KoshRecurringStatus) =>
    apiClient
      .post<KoshRecurringInvoice>(`/kosh/recurring-invoices/${id}/transitions`, { to })
      .then((r) => r.data),
  run: (id: string) =>
    apiClient.post(`/kosh/recurring-invoices/${id}/run`, {}).then((r) => r.data),
};
